import React, { Component } from "react";
// Import "./dropdown.scss";
import Dropdown from "@acadia-ui/dropdown";
import Tooltip, { TOOLTIP_POSITION } from "@acadia-ui/tooltip";
import _ from "lodash";

class DropdownV2 extends Component {
	constructor(props) {
		super(props);
		this.customStyles = {
			control: (base, state) => ({
				...base,
				background: "white",
				border: "solid 1px rgba(113, 113, 116, 0.2)",
				borderRadius: 0,
				minHeight: "40px",
				"&:hover": {
					boxShadow: "0 1px 0 0px #5a6872"
				},
				boxShadow: state.isFocused ? "0 2px 0 0px #50c0e8" : "0 1px 0 0px #5a6872",
				position: "relative"
			}),
			menu: (base, state) => ({
				...base,
				zIndex: 2
				// Position: 'absolute',
				// top: '0',
			})
		};
		(this.dot = (color = "#ccc") => ({
			alignItems: "center",
			display: "flex",

			":before": {
				backgroundColor: color,
				borderRadius: 10,
				content: '" "',
				display: "block",
				marginRight: 8,
				height: 10,
				width: 10
			}
		})),
			(this.colorStyles = {
				option: (styles, { data }) => ({ ...styles, ...this.dot(data.color) }),
				singleValue: (styles, { data }) => ({ ...styles, ...this.dot(data.color) })
			}),
			(this.dropdown = React.createRef());
	}

	shouldComponentUpdate(nextProps, nextState) {
		if (
			this.props.value !== nextProps.value ||
			!_.isEqual(this.props.data, nextProps.data) ||
			this.props.isDisabled !== nextProps.isDisabled ||
			this.props.filterOption !== nextProps.filterOption
		) {
			return true;
		}
		return false;
	}

	onChangeFunc = (optionSelected, action) => {
		this.props.handleChange(optionSelected, this.props.name, this.props.dataConfig, this.props.id, this.props.dataType);
	};

	render() {
		return (
			<>
				<Dropdown
					className={`${this.props.className}`}
					// className={`-pub__custom__select ${this.props.className}`}
					// classNamePrefix="-pub"
					// classNamePrefix="sdkfgbasdfhk"
					name={this.props.name}
					value={this.props.value}
					id={this.props.id}
					onChange={this.onChangeFunc}
					options={this.props.data}
					// placeholder={this.props.placeholder}
					multiple={this.props.isMulti}
					dataconfig={this.props.dataConfig}
					dataType={this.props.dataType}
					isClearable={false}
					required={this.props.required}
					isDisabled={this.props.isDisabled}
					isSearchable={true}
					menuShouldScrollIntoView={false}
					{...(this.props.filterOption ? { filterOption: this.props.filterOption } : {})}
				>
					{this.props.label}
					{this.props.fieldDescription && (
						<Tooltip className="field-description-tooltip" title={this.props.fieldDescription} position={TOOLTIP_POSITION.BOTTOM}>
							<i className="icon-info" />
						</Tooltip>
					)}
				</Dropdown>
			</>
		);
	}
}

/* This should come in handy */
DropdownV2.defaultProps = {
	isMulti: false,
	isClearable: true
};

export default DropdownV2;
